export default "__VITE_ASSET__BCxoZ92C__"